<template>
  <div class="col-md-8 col-lg-8 offset-md-2 offset-lg-2 page profile-ds eh-ds">
    <div class="form" ref="formContainer">
      <p v-if="loadError" class="text-danger">{{ loadError }}</p>
      <p v-else-if="loading" class="text-muted">Loading profile…</p>
      <form v-else @submit.prevent="handleSubmit" id="form_bio">
        <h1 class="profile__header mt-md-0 mt-0">PROFILE</h1>
        <div class="row">
          <div class="col-md-6 col-lg-6 col-12 form-group">
            <label for="profileFirstName" class="profile__label">FIRST NAME</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              id="profileFirstName"
              v-model="profile.firstName"
              required
            />
          </div>
          <div class="col-md-6 col-lg-6 col-12 form-group">
            <label for="profileLastName" class="profile__label">LAST NAME</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              id="profileLastName"
              v-model="profile.lastName"
              required
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
            <label for="profileDOB" class="profile__label">DATE OF BIRTH</label>
            <input
              :disabled="!editing"
              type="date"
              class="form-control profile_input"
              id="profileDOB"
              v-model="profile.dob"
            />
            <small>MM-DD-YYYY</small>
          </div>
          <div v-if="profile.can_edit_gender" class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
            <label for="profileGender" class="profile__label">GENDER</label>
            <select
              :disabled="!editing"
              class="form-select profile_input"
              id="profileGender"
              v-model="profile.gender"
            >
              <option value="">Please select</option>
              <option v-for="gender in genders" :key="gender.id" :value="gender.value">
                {{ gender.value }}
              </option>
            </select>
          </div>
          <div v-if="profile.can_edit_npi" class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
            <label for="profileNpi" class="profile__label">NPI</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              id="profileNpi"
              v-model="profile.npi"
            />
          </div>
          <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
            <label for="profileCommPref" class="profile__label">PREFERRED COMMUNICATION</label>
            <select
              :disabled="!editing"
              class="form-select profile_input"
              id="profileCommPref"
              v-model="profile.communicationPreference"
            >
              <option value="Email">Email</option>
              <option value="SMS">SMS</option>
              <option value="Phone">Phone</option>
              <option value="All">SMS, Phone &amp; Email</option>
            </select>
          </div>
        </div>

        <h1 class="profile__header">INTERNAL INFORMATION</h1>
        <div class="row">
          <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
            <label for="profileId" class="profile__label">ID NUMBER</label>
            <input
              disabled
              type="text"
              class="form-control"
              id="profileId"
              :value="profile.unique_ID"
            />
          </div>
          <div class="form-group">
            <label for="profileUsername" class="profile__label">USERNAME</label>
            <input
              disabled
              type="text"
              class="form-control"
              id="profileUsername"
              :value="profile.username"
            />
          </div>
          <div class="col-md-12 col-lg-12 col-12 form-group">
            <label for="profileEmail" class="profile__label">EMAIL ADDRESS</label>
            <input
              disabled
              id="profileEmail"
              type="text"
              class="form-control"
              :value="profile.email"
            />
          </div>
        </div>

        <h1 class="profile__header">CONTACT INFORMATION</h1>
        <div class="row">
          <div class="col-md-8 col-lg-8 col-12 form-group">
            <label for="profilePhone" class="profile__label">PRIMARY PHONE</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              id="profilePhone"
              v-model="profile.phone1"
            />
          </div>
          <div class="col-md-4 col-lg-4 col-12 form-group">
            <label for="profilePhoneType" class="profile__label">PHONE TYPE</label>
            <select
              :disabled="!editing"
              class="form-select profile_input"
              id="profilePhoneType"
              v-model.number="profile.phone1Type"
            >
              <option :value="0">Please select one of the following</option>
              <option v-for="phone in phoneTypes" :key="phone.id" :value="phone.id">
                {{ phone.type }}
              </option>
            </select>
          </div>
          <div class="col-md-8 col-lg-8 col-12 form-group">
            <label class="profile__label">SECONDARY PHONE</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              id="profilePhone2"
              v-model="profile.phone2"
            />
          </div>
          <div class="col-md-4 col-lg-4 col-12 form-group">
            <label class="profile__label">PHONE TYPE</label>
            <select
              :disabled="!editing"
              class="form-select profile_input"
              id="profilePhoneType2"
              v-model.number="profile.phone2Type"
            >
              <option :value="0">Please select one of the following</option>
              <option v-for="phone in phoneTypes" :key="'p2-' + phone.id" :value="phone.id">
                {{ phone.type }}
              </option>
            </select>
          </div>
        </div>

        <h1 class="profile__header">PRIMARY ADDRESS</h1>
        <div class="row">
          <div class="col-md-12 col-lg-12 col-12 form-group">
            <label class="profile__label">ADDRESS 1</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              v-model="profile.address"
            />
          </div>
          <div class="col-md-12 col-lg-12 col-12 form-group">
            <label class="profile__label">ADDRESS 2</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              v-model="profile.addr2"
            />
          </div>
          <div class="col-md-6 col-lg-6 col-12 form-group">
            <label class="profile__label">CITY</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              v-model="profile.city"
            />
          </div>
          <div class="col-md-3 col-lg-3 col-12 form-group">
            <label class="profile__label">STATE</label>
            <select
              :disabled="!editing"
              class="form-select profile_input"
              v-model="profile.state"
            >
              <option value="">Please select one of the following</option>
              <option
                v-for="state in states"
                :key="state.abbr || state.name"
                :value="state.abbr || state.name"
              >
                {{ state.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3 col-lg-3 col-12 form-group">
            <label class="profile__label">ZIP</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              v-model="profile.zip"
            />
          </div>
        </div>

        <div class="form-check">
          <input
            :disabled="!editing"
            class="form-check-input profile_input"
            type="checkbox"
            id="mailingSameAsPrimary"
            @change="handleMailingCheckbox"
          />
          <label class="form-check-label profile__checkbox" for="mailingSameAsPrimary">
            My mailing address is the same as my primary address.
          </label>
        </div>

        <h1 class="profile__header">MAILING ADDRESS</h1>
        <div class="row">
          <div class="col-md-12 col-lg-12 col-12 form-group">
            <label class="profile__label">ADDRESS 1</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              v-model="profile.maddr"
            />
          </div>
          <div class="col-md-12 col-lg-12 col-12 form-group">
            <label class="profile__label">ADDRESS 2</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              v-model="profile.maddr2"
            />
          </div>
          <div class="col-md-6 col-lg-6 col-12 form-group">
            <label class="profile__label">CITY</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              v-model="profile.mcity"
            />
          </div>
          <div class="col-md-3 col-lg-3 col-12 form-group">
            <label class="profile__label">STATE</label>
            <select
              :disabled="!editing"
              class="form-select profile_input"
              v-model="profile.mstate"
            >
              <option value="">Please select one of the following</option>
              <option
                v-for="state in states"
                :key="'m-' + (state.abbr || state.name)"
                :value="state.abbr || state.name"
              >
                {{ state.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3 col-lg-3 col-12 form-group">
            <label class="profile__label">ZIP</label>
            <input
              :disabled="!editing"
              type="text"
              class="form-control profile_input"
              v-model="profile.mzip"
            />
          </div>
        </div>

        <div class="btn-container">
          <button
            v-if="!editing"
            class="btn btn-primary float-end profile edit"
            type="button"
            @click="startEdit"
          >
            <font-awesome-icon :icon="['fas', 'pen']" /> EDIT
          </button>
          <button
            v-else
            class="btn btn-primary float-end"
            type="button"
            @click="cancelEdit"
          >
            <font-awesome-icon :icon="['fas', 'ban']" /> CANCEL
          </button>
          <button v-if="editing" class="btn btn-primary float-end" type="submit" :disabled="saving">
            <font-awesome-icon :icon="['fas', 'check']" /> {{ saving ? "SAVING…" : "SUBMIT" }}
          </button>
        </div>

        <h1 v-if="!isManager" class="profile__header">
          UPLOADED PDFS
          <button type="button" @click="showAddPdf">
            <font-awesome-icon :icon="['fas', 'plus-circle']" />
          </button>
        </h1>
        <AccordionComponent
          v-if="insuranceDocs.length || licenseDocs.length || otherDocs.length"
          :multiple="true"
        >
          <AccordionTab v-if="insuranceDocs.length" header="Insurance PDFs">
            <div class="pdfText">
              <span v-for="doc in insuranceDocs" class="pdfLink" :key="'insurance' + doc.id">
                <a
                  v-if="doc.availability === 'available' && doc.fileClass !== 'other'"
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="keyonFileUrl(doc.fileUid)"
                  >{{ doc.name }}</a
                >
                <button
                  v-else-if="doc.availability === 'available'"
                  type="button"
                  class="btn btn-link p-0 align-baseline"
                  @click="downloadDoc(doc)"
                >{{ doc.name }}</button>
                <span v-else
                  >{{ doc.name }} ({{ doc.availability === 'scan_pending' ? scanPendingText : documentUnavailableText }})</span
                >
              </span>
            </div>
          </AccordionTab>
          <AccordionTab v-if="licenseDocs.length" header="License PDFs">
            <div class="pdfText">
              <span v-for="doc in licenseDocs" class="pdfLink" :key="'license' + doc.id">
                <a
                  v-if="doc.availability === 'available' && doc.fileClass !== 'other'"
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="keyonFileUrl(doc.fileUid)"
                  >{{ doc.name }}</a
                >
                <button
                  v-else-if="doc.availability === 'available'"
                  type="button"
                  class="btn btn-link p-0 align-baseline"
                  @click="downloadDoc(doc)"
                >{{ doc.name }}</button>
                <span v-else
                  >{{ doc.name }} ({{ doc.availability === 'scan_pending' ? scanPendingText : documentUnavailableText }})</span
                >
              </span>
            </div>
          </AccordionTab>
          <AccordionTab v-if="otherDocs.length" header="Other PDFs">
            <div class="pdfText">
              <span v-for="doc in otherDocs" class="pdfLink" :key="'other' + doc.id">
                <a
                  v-if="doc.availability === 'available' && doc.fileClass !== 'other'"
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="keyonFileUrl(doc.fileUid)"
                  >{{ doc.name }}</a
                >
                <button
                  v-else-if="doc.availability === 'available'"
                  type="button"
                  class="btn btn-link p-0 align-baseline"
                  @click="downloadDoc(doc)"
                >{{ doc.name }}</button>
                <span v-else
                  >{{ doc.name }} ({{ doc.availability === 'scan_pending' ? scanPendingText : documentUnavailableText }})</span
                >
              </span>
            </div>
          </AccordionTab>
        </AccordionComponent>

        <div v-if="!isViewingPatientChart" class="change-password-section">
          <router-link to="/user/change-password" class="btn btn-primary change-password-btn">
            Change Password
          </router-link>
        </div>
      </form>
      <form v-if="showingAddPdf" id="add-pdf-modal" class="add-pdf-modal">
        <div class="inner-pdf-modal">
          <div class="form-group2 pdfheader">
            <label>Upload a new PDF</label>
          </div>
          <div class="form-group2 pdftype">
            <label>PDF Type: </label>
            <select id="pdf-type" class="pdf-type" v-model="pdfType">
              <option value="license">License</option>
              <option value="insurance">Insurance</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div class="form-group2 pdffields">
            <input required type="file" id="pdf-file" class="pdf-file" :accept="credentialAccept" />
          </div>
          <div
            v-if="pdfType === 'license' || pdfType === 'insurance'"
            class="form-group2 pdffields"
          >
            <input type="checkbox" class="pdf-latest" v-model="latestPdf" />
            Latest version?
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-primary" @click.prevent="addPdf">
              Save
            </button>
            <button type="button" class="btn btn-secondary" @click="resetAddPdf">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getSelfProfile, updateSelfProfile } from "@/api/profileApi";
import { emptySelfProfile, normalizeSelfProfile } from "@/utils/selfProfileForm";
import { DOCUMENT_UNAVAILABLE_TEXT, SCAN_PENDING_TEXT, keyonFileUrl } from "@/utils/fileUrl";
import { downloadKeyonFile, downloadRefusalText, listCredentialDocuments, uploadCredentialDocument } from "@/api/keyonFiles";
import { CREDENTIAL_ACCEPT, mapCredentialItems, validateCredentialFile } from "@/utils/credentialDocuments";
import { isViewingPatientChart as sessionIsViewingPatientChart } from "@/data/getters";
import { useSessionSelfStore } from "@/stores/sessionSelf";
import gendersList from "@/data/genders";
import $ from "jquery";
import { h } from "vue";

export default {
  name: "user-profile",
  props: ["restricted"],
  data() {
    return {
      credentialAccept: CREDENTIAL_ACCEPT,
      scanPendingText: SCAN_PENDING_TEXT,
      documentUnavailableText: DOCUMENT_UNAVAILABLE_TEXT,
      allData: this.$store.getters["login/getAllData"],
      profile: emptySelfProfile(),
      profileBaseline: emptySelfProfile(),
      loading: true,
      loadError: "",
      editing: false,
      saving: false,
      insuranceDocs: [],
      licenseDocs: [],
      otherDocs: [],
      isManager: false,
      showingAddPdf: false,
      pdfType: "license",
      latestPdf: false,
    };
  },
  computed: {
    genders() {
      return (this.allData && this.allData.genders) || gendersList;
    },
    states() {
      return (this.allData && this.allData.states) || [];
    },
    phoneTypes() {
      return (this.allData && this.allData.phoneTypes) || [
        { id: 1, type: "CELL" },
        { id: 2, type: "HOME" },
        { id: 3, type: "WORK" },
      ];
    },
    isViewingPatientChart() {
      return !!sessionIsViewingPatientChart(this.allData);
    },
  },
  async mounted() {
    await this.loadProfile();
    this.getPdfList();
  },
  methods: {
    async loadProfile() {
      this.loading = true;
      this.loadError = "";
      try {
        const r = await getSelfProfile();
        if (!r.ok) {
          this.loadError = r.message || "Could not load profile";
          this.profile = emptySelfProfile();
          this.profileBaseline = emptySelfProfile();
          return;
        }
        this.profile = normalizeSelfProfile(r.profile);
        this.profileBaseline = normalizeSelfProfile(r.profile);
        // Keep Pinia session actor in sync with MySQL self (nav / messaging).
        useSessionSelfStore().setFromProfile(r.profile);
      } catch (e) {
        this.loadError = e?.message || "Could not load profile";
      } finally {
        this.loading = false;
      }
    },
    startEdit() {
      this.editing = true;
    },
    cancelEdit() {
      this.profile = normalizeSelfProfile(this.profileBaseline);
      this.editing = false;
    },
    handleMailingCheckbox(e) {
      if (!e?.target?.checked) return;
      this.profile.maddr = this.profile.address;
      this.profile.maddr2 = this.profile.addr2;
      this.profile.mcity = this.profile.city;
      this.profile.mstate = this.profile.state;
      this.profile.mzip = this.profile.zip;
    },
    async handleSubmit() {
      this.saving = true;
      try {
        const r = await updateSelfProfile(this.profile);
        if (!r.ok) {
          this.$swal({
            type: "error",
            title: "Unable to save",
            text: r.message || "Error: Please contact website administration",
          });
          return;
        }
        this.profile = normalizeSelfProfile(r.profile);
        this.profileBaseline = normalizeSelfProfile(r.profile);
        // Push saved MySQL row into sessionSelf so chrome updates without reload.
        useSessionSelfStore().setFromProfile(r.profile);
        this.editing = false;
        this.$swal({
          type: "success",
          title: "Profile updated",
          text: "Your profile has been saved.",
        });
      } catch (e) {
        this.$swal({
          type: "error",
          title: "Unable to save",
          text: "Error: Please contact website administration",
        });
        console.dir(e);
      } finally {
        this.saving = false;
      }
    },
    showAddPdf() {
      this.showingAddPdf = true;
    },
    resetAddPdf() {
      this.showingAddPdf = false;
      this.pdfType = "license";
      this.latestPdf = false;
    },
    keyonFileUrl,
    async downloadDoc(doc) {
      const r = await downloadKeyonFile(doc.fileUid, doc.name);
      if (r.ok) return;
      if (r.state === "scan_pending") doc.availability = "scan_pending";
      const text = downloadRefusalText(r.state);
      if (text) alert(text);
    },
    async addPdf() {
      const file = $("#pdf-file")[0]?.files?.[0];
      const v = validateCredentialFile(file);
      if (!v.ok) {
        this.$swal({ type: "error", title: "Unable to upload", text: v.error });
        return;
      }
      let loader = this.$loading.show(
        {},
        {
          after: () => h("div", {}, "Transfering data to pdf viewer..."),
        }
      );
      try {
        const r = await uploadCredentialDocument({
          file,
          category: this.pdfType,
          latest: this.latestPdf === true,
          accountnumber: this.profile.accountnumber,
          externid: this.profile.unique_ID,
        });
        if (r.ok) {
          this.$swal({
            type: "success",
            title: "PDF successfully uploaded",
            text: "The PDF should appear in the Uploaded PDFs section",
          });
          this.resetAddPdf();
          this.getPdfList();
        } else {
          this.$swal({
            type: "error",
            title: "Unable to upload",
            text: r.message || "Upload failed",
          });
        }
      } finally {
        loader.hide();
        loader = null;
      }
    },
    async getPdfList() {
      const r = await listCredentialDocuments({ scope: "own" });
      const docs = r.ok ? mapCredentialItems(r.items, { scope: "own" }) : [];
      this.insuranceDocs = docs.filter((d) => d.type === "insurance");
      this.licenseDocs = docs.filter((d) => d.type === "license");
      this.otherDocs = docs.filter((d) => d.type === "misc");
    },
  },
};
</script>

<style scoped lang="scss">
/* Colors/fonts live in the stylebook (.eh-ds in brand-ds.scss). Layout stays here. */

.pdfText {
  display: flex;
  flex-direction: column;
}

.pdfLink {
  font-weight: 400;
}

.page {
  background-color: #fff;
  margin: 1.5rem auto;
  padding: 2rem;
  margin-bottom: 100px;
}
.profile__header {
  font-size: 1.5rem;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1em;
}
.profile__label {
  font-size: 0.8rem;
}
.profile__checkbox {
  font-size: 0.8rem;
}
input,
select {
  font-size: 0.8rem;
}
.btn-container {
  margin-top: 1rem;
  .btn {
    font-size: 0.8rem;
    margin: 2px;
  }
  padding-bottom: 3rem;
}
.licenseInfo {
  display: flex;
  justify-content: center;
}

.add-pdf-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.inner-pdf-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}
.form-group2 label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 16px;
}
.form-group2.pdfheader {
  justify-content: center;
}
.form-group2.pdftype {
  justify-content: space-between;
}
.form-group2 {
  display: flex;
}
.form-group2 select {
  font-size: 1.2rem;
}
.pdf-file {
  font-size: 1rem;
}

.change-password-section {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
  text-align: center;
}

.change-password-btn {
  font-size: 0.9rem;
  padding: 0.5rem 1.5rem;
}
</style>
